import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import { SET_LOCK_SCREEN } from 'store/settings/actions'
import { useTranslation } from 'react-i18next'
//import io from 'socket.io-client'
import DatePicker from "react-datepicker";
import MulticardImage from '../../assets/images/payments/multicard.png';


// Reactstrap
import { Modal } from 'react-bootstrap'
import {
	Dropdown,
	DropdownItem,
	DropdownMenu,
	DropdownToggle
} from "reactstrap"

// Import menuDropdown
import LanguageDropdown from "../topbarDropdown/LanguageDropdown";
import PosNotificationsBell from "./PosNotificationsBell";

import logoIcon from "../../assets/images/logo.png";
import clickImage from '../../assets/images/payments/click-dark.png';
import PaymeImage from '../../assets/images/payments/payme.png';
import titulAlmaz from '../../assets/images/tituls/алмаз-removebg-preview.png';
import titulBronza from '../../assets/images/tituls/бронза-removebg-preview.png';
import titulZoloto from '../../assets/images/tituls/золото-removebg-preview.png';
import titulPlatina from '../../assets/images/tituls/платина-removebg-preview.png';
import titulSerebro from '../../assets/images/tituls/серебро-removebg-preview.png';

import { POST, GET } from 'helpers/api'
import { clearTemporaryStorage, formatMoney } from 'helpers/helpers'
import axios from "axios";
// import base64 from 'base-64';

// Saharlik/iftorlik statik jadval (API bo'lmasa): sana -> { saharlik, iftorlik } (HH:MM:SS)
function getStaticSaharlikIftorlik() {
	const list = [
		{ date: "2026-02-19", saharlik: "05:54:00", iftorlik: "18:05:00" },
		{ date: "2026-02-20", saharlik: "05:53:00", iftorlik: "18:06:00" },
		{ date: "2026-02-21", saharlik: "05:51:00", iftorlik: "18:07:00" },
		{ date: "2026-02-22", saharlik: "05:50:00", iftorlik: "18:08:00" },
		{ date: "2026-02-23", saharlik: "05:48:00", iftorlik: "18:10:00" },
		{ date: "2026-02-24", saharlik: "05:47:00", iftorlik: "18:11:00" },
		{ date: "2026-02-25", saharlik: "05:45:00", iftorlik: "18:12:00" },
		{ date: "2026-02-26", saharlik: "05:44:00", iftorlik: "18:13:00" },
		{ date: "2026-02-27", saharlik: "05:42:00", iftorlik: "18:14:00" },
		{ date: "2026-02-28", saharlik: "05:41:00", iftorlik: "18:15:00" },
		{ date: "2026-03-01", saharlik: "05:39:00", iftorlik: "18:16:00" },
		{ date: "2026-03-02", saharlik: "05:37:00", iftorlik: "18:17:00" },
		{ date: "2026-03-03", saharlik: "05:36:00", iftorlik: "18:18:00" },	
		{ date: "2026-03-04", saharlik: "05:34:00", iftorlik: "18:19:00" },
		{ date: "2026-03-05", saharlik: "05:33:00", iftorlik: "18:20:00" },
		{ date: "2026-03-06", saharlik: "05:31:00", iftorlik: "18:21:00" },
		{ date: "2026-03-07", saharlik: "05:29:00", iftorlik: "18:22:00" },
		{ date: "2026-03-08", saharlik: "05:28:00", iftorlik: "18:23:00" },
		{ date: "2026-03-09", saharlik: "05:26:00", iftorlik: "18:24:00" },
		{ date: "2026-03-10", saharlik: "05:24:00", iftorlik: "18:25:00" },
		{ date: "2026-03-11", saharlik: "05:23:00", iftorlik: "18:26:00" },
		{ date: "2026-03-12", saharlik: "05:21:00", iftorlik: "18:27:00" },
		{ date: "2026-03-13", saharlik: "05:19:00", iftorlik: "18:28:00" },
		{ date: "2026-03-14", saharlik: "05:18:00", iftorlik: "18:29:00" },
		{ date: "2026-03-15", saharlik: "05:16:00", iftorlik: "18:30:00" },
		{ date: "2026-03-16", saharlik: "05:14:00", iftorlik: "18:31:00" },
		{ date: "2026-03-17", saharlik: "05:13:00", iftorlik: "18:32:00" },
		{ date: "2026-03-18", saharlik: "05:11:00", iftorlik: "18:33:00" },
		{ date: "2026-03-19", saharlik: "05:09:00", iftorlik: "18:37:00" },
		{ date: "2026-03-20", saharlik: "05:08:00", iftorlik: "18:39:00" },
	];
	const map = {};
	list.forEach((row) => { map[row.date] = { saharlik: row.saharlik, iftorlik: row.iftorlik }; });
	return map;
}

function Header() {
	const { t } = useTranslation()
	const navigate = useNavigate();
	const dispatch = useDispatch()

	//const socketRef = useRef()

	const layoutSelector = useSelector(state => state.Layout)

	const role = localStorage.getItem('role')

	const [modalLogout, setModalLogout] = useState(false)
	const [balance, setBalance] = useState(0)
	const [notifications, setNotifications] = useState([]);
	const [showDropdown, setShowDropdown] = useState(false);
	const [selectedNotification, setSelectedNotification] = useState(null);

	const [billingMenu, setBillingMenu] = useState(false)
	const [posData, setPosData] = useState([]);
	const [PosTarif, setPosTarif] = useState([]);
	const [posDataAll, setPosDataAll] = useState([]);
	const [showModalClick, setShowModalClick] = useState(false);
	const [selectedPosId, setSelectedPosId] = useState(null);
	const [paidFromDateClick, setPaidFromDateClick] = useState(new Date());
	const [amountIn, setAmountIn] = useState("");

	const [rightDropdownOpen, setRightDropdownOpen] = useState(false);
	const [ShowPorfile, setShowPorfile] = useState(false);
	const [showPaymentModalClick, setshowPaymentModalClick] = useState(false);
	const [PaymentMethod, setPaymentMethod] = useState(0);

	const toggleRightDropdown = () => {
		setRightDropdownOpen(!rightDropdownOpen);
	};

	async function getPoses() {
		const response = await GET('/services/web/api/pos-helper')
		if (response) {
			setPosData(response)
		}

		const postarif = await GET('/services/web/api/pos-pageList')
		if (postarif) {
			setPosTarif(postarif)
		}


		const responseAll = await GET('/services/web/api/pos-helper-all')
		if (responseAll) {
			setPosDataAll(responseAll)
		}
	}

	// Handle number input change
	const handleNumberChange = (event) => {
		const value = event.target.value;
		if (/^\d*$/.test(value)) { // Ensure input is an integer
			setAmountIn(value);
		}
	};

	useEffect(() => {
		getPoses()
	}, [])

	useEffect(() => {
		const handler = (e) => {
			setSelectedPosId(String(e.detail.posId));
			setAmountIn(String(e.detail.amountNeeded));
			setShowModalClick(true);
		};
		window.addEventListener('open-billing-payment', handler);
		return () => window.removeEventListener('open-billing-payment', handler);
	}, [])


	const toggleBilling = () => {
		setBillingMenu(!billingMenu)
	}

	/* CLICK */
	// Handle select change
	const handleSelectChangeClick = (event) => {
		setSelectedPosId(event.target.value)
		console.log(PosTarif);

		let selectedPos = PosTarif.filter(pos => Number(pos.id) === Number(event.target.value))[0];
		console.log(selectedPos);
		if (Number(selectedPos?.tariffId) === 1) {
			setAmountIn("100000");
		} else if (Number(selectedPos?.tariffId) === 2) {
			setAmountIn("150000");
		} else if (Number(selectedPos?.tariffId) === 3) {
			setAmountIn("250000");
		}
	};

	const handleDateChangeClick = (event) => setPaidFromDateClick(event);

	// Open modal on button click
	const handleOpenModalClick = () => setShowModalClick(true);

	// Close modal
	const handleCloseModalClick = () => {
		setShowModalClick(false);
		setSelectedPosId(null);
		setAmountIn("");
	};

	const redirectToClick = async () => {
		try {
			const sendData = {
				id: selectedPosId,
				amountIn: String(amountIn).replace(/\s/g, ''), // Remove spaces
				paidFrom: new Date()
			};
			// Replace with your actual API endpoint
			const response = await POST('/services/web/api/get-click-url', sendData, { loader: true })

			if (response && response.data && response.data.url) {
				const redirectUrl = response.data.url;
				console.log(redirectUrl);

				// Redirect to the URL received from the API
				window.location.href = redirectUrl;
			} else {
				console.error('Failed to fetch URL');
			}
		} catch (error) {
			console.error('Error:', error);
		}
	};

	const redirectToPayme = async () => {
		try {
			const sendData = {
				id: selectedPosId,
				amountIn: String(amountIn).replace(/\s/g, ''),
				callbackUrl: window.location.href
			};
			const response = await POST('/services/web/api/get-payme-url', sendData, { loader: true });

			if (response && response.data && response.data.url) {
				window.location.href = response.data.url;
			} else {
				console.error('Failed to fetch Payme URL');
			}

		} catch (error) {
			console.error('Error in redirectToPayme:', error);
		}
	};

	const redirectToMulticard = async () => {
		try {
			if (!selectedPosId) return;

			// Prepare values
			const amountSumStr = String(amountIn || '').replace(/\s/g, '');
			const amountSumNum = Number(amountSumStr);
			if (!Number.isFinite(amountSumNum) || amountSumNum <= 0) {
				console.error('Invalid amountIn:', amountIn);
				return;
			}
			const amountTiyin = Math.trunc(amountSumNum * 100); // UZS → tiyin
			const invoiceId = `${selectedPosId}-${Date.now()}`;

			// Build payload for proxy (exact Multicard invoice body)
			const payload = {
				store_id: 2735,
				amount: amountTiyin,
				invoice_id: invoiceId,
				pos_id: String(selectedPosId),
				return_url: window.location.href,
				callback_url: `${process.env.REACT_APP_PROD_SERVER_URL}/services/web/api/multicard/callback`,
				ofd: [
					{
						name: "Услуги по предоставлению/разрешению права пользования (в том числе лицензии, сублицензии) программным обеспечением",
						price: amountTiyin,
						qty: 1,
						spic: "10305008003000000",
						package_code: 1546532,
						total: amountTiyin
					}
				]
			};

			console.log(payload)

			// Call your backend proxy (no CORS issues)
			const res = await POST('/services/web/api/multicard/invoice-proxy', payload, { loader: true });

			// Extract short_link (works with both wrapped and plain responses)
			const data = res?.data || res;
			const shortLink = data?.data?.short_link || data?.short_link;

			if (!shortLink) {
				console.error('No short_link in proxy response', data);
				return;
			}

			// Redirect to third-party payment page
			window.location.href = shortLink;
		} catch (e) {
			console.error('redirectToMulticard (proxy) failed', e);
		}
	};





	const isButtonDisabledClick = amountIn < 1000 || !selectedPosId || !paidFromDateClick;
	/* END CLICK */

	function toggleFullscreen() {
		if (
			!document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
			!document.webkitFullscreenElement
		) {
			// current working methods
			if (document.documentElement.requestFullscreen) {
				document.documentElement.requestFullscreen();
			} else if (document.documentElement.mozRequestFullScreen) {
				document.documentElement.mozRequestFullScreen();
			} else if (document.documentElement.webkitRequestFullscreen) {
				document.documentElement.webkitRequestFullscreen(
					Element.ALLOW_KEYBOARD_INPUT
				);
			}
		} else {
			if (document.cancelFullScreen) {
				document.cancelFullScreen();
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen();
			} else if (document.webkitCancelFullScreen) {
				document.webkitCancelFullScreen();
			}
		}
	}

	function lockScreen() {
		dispatch(SET_LOCK_SCREEN())
	}

	function tToggle() {
		var body = document.body;
		let btn = document.querySelector('.navbar-header')
		btn.classList.toggle('left-margin')
		body.classList.toggle("vertical-collpsed");
		body.classList.toggle("sidebar-enable");
	}


	async function logout() {
		if (process.env.NODE_ENV === 'development') {
			dispatch({ type: 'USER_LOGGED_OUT', payload: null })
			clearTemporaryStorage()
			navigate('/auth/login')
			window.location.reload()
			return
		}
		const response = await POST('/auth/logout')
		if (response) {
			clearTemporaryStorage()
			navigate('/auth/login')
			window.location.reload()
		}
	}

	async function getBalance() {
		const response = await GET('/services/web/api/pos-balance')
		setBalance(response)
	}

	async function getNotifications() {
		const response = await GET('/services/web/api/unread-notifications')
		setNotifications(response)
	}

	const handleDropdownToggle = () => {
		setShowDropdown(!showDropdown);
	};

	const handleNotificationClick = (notification) => {
		setSelectedNotification(notification);
	};

	const handleCloseModal = () => {
		setSelectedNotification(null);
	};



	let locale = "ru"
	if (localStorage.getItem("I18N_LANGUAGE") === 'ru') locale = "ru"
	else if (localStorage.getItem("I18N_LANGUAGE") === 'uz-Latn-UZ') { locale = "lat" }
	else if (localStorage.getItem("I18N_LANGUAGE") === 'uz-Cyrl-UZ') { locale = "cyr" }


	useEffect(() => {
		//socketConnection()
		if (role !== 'ROLE_ORGANIZATION') {
			getBalance()
			getNotifications()
		}

		// return () => {
		// 	socketRef?.current?.disconnect()
		// }
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const [shortTexts, setShortTexts] = useState([]);

	useEffect(() => {
		// Function to process and extract plain text for each language
		const processHtmlContentByLanguage = (htmlContent) => {
			try {
				// Parse the JSON message
				const parsedContent = JSON.parse(htmlContent);

				// Create a temporary div element for each language
				const processText = (html) => {
					const tempDiv = document.createElement('div');
					tempDiv.innerHTML = html;
					return tempDiv.textContent || tempDiv.innerText || '';
				};

				// Extract plain text for each language
				return {
					ru: processText(parsedContent.ru || ''),
					lat: processText(parsedContent.lat || ''),
					cyr: processText(parsedContent.cyr || '')
				};
			} catch (error) {
				console.error('Error parsing or processing content:', error);
				return { ru: 'Invalid content', lat: 'Invalid content', cyr: 'Invalid content' };
			}
		};

		// Process each notification
		const processedTexts = notifications.map((item) => ({
			id: item.id,
			createdAt: item.createdAt,
			...processHtmlContentByLanguage(item.message)
		}));

		// Log the processed messages
		console.log(processedTexts);

		// Update the state or handle the processed texts if needed
		setShortTexts(processedTexts);
		// setProcessedTexts(processedTexts);
	}, [notifications]);

	const PAYMENT_METHODS = [
		{ id: 1, name: "Click", image: clickImage },
		{ id: 2, name: "Payme", image: PaymeImage },
		{ id: 3, name: "Multicard", image: MulticardImage }
	];

// Static titul selection: show the gold titul by default.
const titulImageToShow = titulZoloto;

// User points (assumption: stored in localStorage as 'userPoints'; fallback to 0)
const userPoints = Number(localStorage.getItem('userPoints')) || 0;

// Tituls definition: ordered by progression
const TITULS = [
	{ key: 'bronze', name: 'Bronza', points: 500, image: titulBronza, benefits: ['Discount 2%', 'Priority support'] },
	{ key: 'serebro', name: 'Serebro', points: 1500, image: titulSerebro, benefits: ['Discount 5%', 'Priority support', 'Early access'] },
	{ key: 'zoloto', name: 'Zoloto', points: 3000, image: titulZoloto, benefits: ['Discount 10%', 'Dedicated manager', 'Beta features'] },
	{ key: 'platina', name: 'Platina', points: 5000, image: titulPlatina, benefits: ['Discount 15%', 'Dedicated manager', 'Custom integrations'] },
	{ key: 'almaz', name: 'Almaz', points: 10000, image: titulAlmaz, benefits: ['All Platina benefits', 'Invitation to partner program', 'Exclusive events'] },
];

const [showTitulModal, setShowTitulModal] = useState(false);
// Carousel state for tituls
const [titulIndex, setTitulIndex] = useState(() => {
	// start at highest achieved titul or 0
	for (let i = TITULS.length - 1; i >= 0; i--) {
		if (userPoints >= TITULS[i].points) return i;
	}
	return 0;
});
const touchStartX = useRef(null);
const touchEndX = useRef(null);

// animation states for sliding transition
const [isAnimating, setIsAnimating] = useState(false);
const [incomingIndex, setIncomingIndex] = useState(null);
const [incomingDirection, setIncomingDirection] = useState(null); // 'next' or 'prev'

const onTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
const onTouchMove = (e) => { touchEndX.current = e.touches[0].clientX; };
const onTouchEnd = () => {
	if (touchStartX.current == null || touchEndX.current == null) return;
	const diff = touchStartX.current - touchEndX.current;
	if (Math.abs(diff) > 30) {
		if (diff > 0) changeToIndex((titulIndex + 1) % TITULS.length); else changeToIndex((titulIndex - 1 + TITULS.length) % TITULS.length);
	}
	touchStartX.current = null; touchEndX.current = null;
};

// compute adjacent indices for previews
const prevTitulIndex = (titulIndex - 1 + TITULS.length) % TITULS.length;
const nextTitulIndex = (titulIndex + 1) % TITULS.length;

// change with animation
const changeToIndex = (targetIndex) => {
	if (targetIndex === titulIndex || isAnimating) return;
	const isNext = targetIndex === nextTitulIndex;
	const direction = isNext ? 'next' : 'prev';
	setIncomingIndex(targetIndex);
	setIncomingDirection(direction);
	setIsAnimating(true);
};

const goNextTitul = () => changeToIndex(nextTitulIndex);
const goPrevTitul = () => changeToIndex(prevTitulIndex);

const finishAnimation = () => {
	if (incomingIndex != null) {
		setTitulIndex(incomingIndex);
	}
	setIncomingIndex(null);
	setIncomingDirection(null);
	setIsAnimating(false);
};



	const OpenPaymentModal = (method_idx) => {
		setPaymentMethod(method_idx)
		setshowPaymentModalClick(true)
	}

	const ClosePaymentModal = () => {
		setshowPaymentModalClick(false)
	}
	const dropdownRef = useRef(null);
	useEffect(() => {
		const handleOutsideClick = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setShowPorfile(false); // Faqat tashqariga bosilganda yopish
			}
		};


		document.addEventListener("mousedown", handleOutsideClick);
		return () => {
			document.removeEventListener("mousedown", handleOutsideClick);
		};
	}, [setShowPorfile]);



	const handleVoiceCommand = () => {
		const recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
		recognition.lang = 'uz-UZ'; // O'zbek tili
		recognition.start();

		recognition.onresult = (event) => {
			const transcript = event?.results?.[0]?.[0]?.transcript;
			console.log(transcript);

			if (transcript?.includes("mahsulot") || transcript?.includes("qabul qilish")) {
				// Foydalanuvchini "Mahsulotlarni qabul qilish" bo'limiga yo'naltirish
				// window.location.href = "/documents-in";
				navigate('/documents-in')
				// Ovozli yordamchi tushuntirish beradi
				// const speech = new SpeechSynthesisUtterance("Mahsulotlarni qabul qilish bo'limiga o'tdingiz. Bu yerda yangi mahsulotlarni qo'shishingiz va ularni ro'yxatdan o'tkazishingiz mumkin.");
				// window.speechSynthesis.speak(speech);
			}
		};
	}

	const telegramLink = `<a href="https://t.me/idokon" target="_blank" rel="noopener noreferrer">@idokon</a>`;


	const [todayPrayerTimes, setTodayPrayerTimes] = useState(null);

	// Bugungi sana YYYY-MM-DD
	const getTodayDateKey = () => {
		const d = new Date();
		const year = d.getFullYear();
		const month = String(d.getMonth() + 1).padStart(2, "0");
		const day = String(d.getDate()).padStart(2, "0");
		return `${year}-${month}-${day}`;
	};

	// HH:MM:SS -> HH:MM
	const formatTime = (str) => {
		if (!str || typeof str !== "string") return "--:--";
		const part = str.trim().split(" ")[0];
		const [h, m] = part.split(":");
		return h != null && m != null ? `${h.padStart(2, "0")}:${m.padStart(2, "0")}` : "--:--";
	};

	// Saharlik / iftorlik vaqtlari — faqat statik jadvaldan (API ishlatilmaydi)
	function getStaticTodayTimes() {
		const key = getTodayDateKey();
		const staticData = getStaticSaharlikIftorlik();
		const row = staticData[key];
		if (row) return { saharlik: formatTime(row.saharlik), iftorlik: formatTime(row.iftorlik) };
		return null;
	}

	useEffect(() => {
		setTodayPrayerTimes(getStaticTodayTimes());
	}, []);

	const getFormattedDate = () => {
		const today = new Date();
		const day = String(today.getDate()).padStart(2, "0"); // Добавляет 0 перед цифрами < 10
		const month = String(today.getMonth() + 1).padStart(2, "0"); // Месяцы начинаются с 0
		const year = today.getFullYear();
		return `${day}.${month}.${year}`;
	};

	// Component ichida:
	const step = 1;              // Qadamni o'zgartirishingiz mumkin (masalan 1000)
	const min = 0;               // Minimal qiymat (xohlovcha)



	const handleIncrement = (id) => {
		let selectedPos = PosTarif.filter(pos => Number(pos.id) === Number(id))[0];
		if (Number(selectedPos?.tariffId) === 1) {
			setAmountIn((Number(amountIn) || 0) + 100000);
		} else if (Number(selectedPos?.tariffId) === 2) {
			setAmountIn((Number(amountIn) || 0) + 150000);
		} else if (Number(selectedPos?.tariffId) === 3) {
			setAmountIn((Number(amountIn) || 0) + 250000);
		}

		// const next = (Number(amountIn) || 0) + step;
		// setAmountIn(next);         // amountIn ni steytdan boshqarayotgan bo'lsangiz
	};

	const handleDecrement = (id) => {
		let selectedPos = PosTarif.filter(pos => Number(pos.id) === Number(id))[0];
		if (amountIn <= 0) return;
		if (Number(selectedPos?.tariffId) === 1) {
			setAmountIn((Number(amountIn) || 0) - 100000);
		} else if (Number(selectedPos?.tariffId) === 2) {
			setAmountIn((Number(amountIn) || 0) - 150000);
		} else if (Number(selectedPos?.tariffId) === 3) {
			setAmountIn((Number(amountIn) || 0) - 250000);
		}
	};


	return (
		<>
			<header
				id="page-topbar"
				className={`header-root ${layoutSelector.showSidebar ? 'sidebar-left' : 'd-none sidebar-active-left'}`}
			>
				{/* 1-qator: hamburger + til + bildirishnoma + qulf + profil (mobil va desktop) */}
				<div className="header-row-1">
					<div className="navbar-header p-0">
						<button
							type="button"
							onClick={() => tToggle()}
							className="btn btn-sm px-3 font-size-16 header-item waves-effect vertical-menu-btn me-2"
							id="vertical-menu-btn"
						>
							<i className="uil-bars fz-20" />
						</button>
					</div>
					<div className="header-actions">
						<LanguageDropdown />
						{/* Saharlik/iftorlik — faqat desktopda shu qatorda */}
						{todayPrayerTimes && (
							<div className="header-prayer-inline d-none d-md-flex align-items-center prayer-time">
								<div className="time-box sahar" title={t('Saharlik')}>
									<span className="moon me-1" />
									<span>{t('Saharlik')}: {todayPrayerTimes.saharlik}</span>
								</div>
								<div className="time-box iftor" title={t('Iftorlik')}>
									<span className="sun me-1" />
									<span>{t('Iftorlik')}: {todayPrayerTimes.iftorlik}</span>
								</div>
							</div>
						)}
						<PosNotificationsBell />
						<button
							type="button"
							onClick={() => handleDropdownToggle()}
							className="btn header-item noti-icon waves-effect me-2 position-relative"
							style={{ padding: '10px', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', outline: 'none' }}
						>
							<i className="uil-bell position-relative" style={{ fontSize: '24px' }}>
								{notifications.length > 0 && (
									<span
										className="position-absolute bg-warning text-white rounded-circle d-flex align-items-center justify-content-center"
										style={{ top: '-5px', right: '-10px', padding: '2px 6px', fontSize: '10px', fontWeight: 'bold', border: '2px solid white' }}
									>
										{notifications.length}
									</span>
								)}
							</i>
							{showDropdown && (
								<div
									className="position-absolute"
									style={{
										top: '50px', right: '0', minWidth: '250px', backgroundColor: '#fff', border: '1px solid #ddd',
										borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', zIndex: 1050, overflow: 'auto', color: '#000',
									}}
								>
									{notifications.length > 0 ? (
										notifications.map((notification) => {
											let parsedMessage = {};
											try { parsedMessage = JSON.parse(notification.message); } catch (e) {}
											const localizedText = parsedMessage[locale] || '';
											const tempDiv = document.createElement('div');
											tempDiv.innerHTML = localizedText;
											const plainText = tempDiv.textContent || tempDiv.innerText || '';
											return (
												<div
													key={notification.id}
													onClick={() => handleNotificationClick(notification)}
													style={{ padding: '12px 16px', borderBottom: '1px solid #f0f0f0', cursor: 'pointer' }}
													className="hover:bg-gray-100"
												>
													{plainText}
												</div>
											);
										})
									) : (
										<div style={{ padding: '12px 16px', color: '#666', fontStyle: 'italic', textAlign: 'center' }}>No notifications</div>
									)}
								</div>
							)}
						</button>
						<button type="button" onClick={() => toggleFullscreen()} className="btn header-item noti-icon waves-effect me-2 d-none d-md-flex">
							<i className="uil-minus-path" />
						</button>
						<button type="button" onClick={() => lockScreen()} className="btn header-item noti-icon waves-effect me-2">
							<i className="uil-lock" />
						</button>
						<div
							style={{ color: ShowPorfile ? '#25B07A' : '' }}
							onClick={() => setShowPorfile(true)}
							role="button"
							tabIndex={0}
							className="cursor btn position-relative d-flex align-items-center p-0"
						>
							<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><g fill="currentColor" fillRule="evenodd" clipRule="evenodd"><path d="M16 9a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-2 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0" /><path d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1M3 12c0 2.09.713 4.014 1.908 5.542A8.99 8.99 0 0 1 12.065 14a8.98 8.98 0 0 1 7.092 3.458A9 9 0 1 0 3 12m9 9a8.96 8.96 0 0 1-5.672-2.012A6.99 6.99 0 0 1 12.065 16a6.99 6.99 0 0 1 5.689 2.92A8.96 8.96 0 0 1 12 21" /></g></svg>
						</div>
						{ShowPorfile && (
							<div
								ref={dropdownRef}
								className="position-absolute"
								style={{
									position: 'fixed', top: '56px', right: '12px', minWidth: '250px',
									backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '8px',
									boxShadow: '0 4px 12px rgba(0,0,0,0.1)', zIndex: 1050, color: '#000',
								}}
								onClick={(e) => e.stopPropagation()}
							>
								<div style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
									<div style={{ padding: '6px 16px' }} className="d-flex align-items-center justify-content-between">
										<span style={{ color: 'gray' }}>{t('LOGIN')}:</span>
										<span className="fs-5">{JSON.parse(localStorage.getItem('authUser'))?.username?.replaceAll('!2929s', '')}</span>
									</div>
									<div style={{ padding: '6px 16px' }} onClick={() => setModalLogout(true)} className="d-flex align-items-center justify-content-between cursor-pointer">
										<span style={{ color: 'gray' }}>{t('LOGOUT')}:</span>
										<span className="fs-5" style={{ color: '#f46a6a' }}><i className="uil-signin" /></span>
									</div>
									<Dropdown style={{ padding: '6px 16px' }} isOpen={billingMenu} toggle={handleOpenModalClick} className="w-100 mt-2">
										<DropdownToggle style={{ width: '100%' }} className="d-flex btn btn-success justify-content-center align-items-center">
											<i className="uil-dollar-sign" style={{ fontSize: '20px' }} />
											<span className="ms-1">{t('MAKE_PAYMENT_FOR_BILLLING')}</span>
										</DropdownToggle>
										<DropdownMenu>
											<DropdownItem onClick={handleOpenModalClick} className="notify-item">
												<img src={clickImage} alt="click" className="me-1" height="20" />
												<span>Click</span>
											</DropdownItem>
										</DropdownMenu>
									</Dropdown>
								</div>
							</div>
						)}
					</div>
				</div>
			</header>


			{/* choose Payment Method */}
			<Modal show={showModalClick} animation={false} centered dialogClassName="update-modal-width" backdrop="static" onHide={handleCloseModalClick}>
				<Modal.Header closeButton>
					<Modal.Title>
						{PAYMENT_METHODS[PaymentMethod].name}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="d-flex gap-3">
					{PAYMENT_METHODS.map((item, index) => {
						return (
							<div onClick={(_) => OpenPaymentModal(index)} style={{ border: "1px solid #34C38F", width: "120px", borderRadius: "10px", }} className=" p-2 d-grid justify-content-center align-items-center text-center gap-1 cursor payment_card">
								<img style={{ width: "60px", height: "60px", borderRadius: "50%" }} className="" src={item.image} alt={item.name} />
								<h5 >{item.name}</h5>
							</div>
						)
					})}
				</Modal.Body>
			</Modal>

			{/* Titul info modal */}
			<Modal show={showTitulModal} animation={false} centered dialogClassName="update-modal-width" backdrop="static" onHide={() => setShowTitulModal(	false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('TITULS') || 'Titullar'}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="d-flex flex-column align-items-center" style={{ minWidth: 320 }}>
						<div style={{ marginBottom: 8 }}><strong>{t('YOUR_POINTS') || 'Your points'}:</strong> {userPoints}</div>
						<div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
							{/* left preview */}
							<div style={{ width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: 0.9, cursor: 'pointer' }} onClick={() => setTitulIndex(prevTitulIndex)}>
								<img src={TITULS[prevTitulIndex].image} alt={TITULS[prevTitulIndex].name} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', borderRadius: 8, boxShadow: '0 4px 12px rgba(0,0,0,0.06)' }} />
							</div>

							{/* center main with animation */}
							<div style={{ position: 'relative', width: 220, height: 220 }}>
								<div
									onTouchStart={onTouchStart}
									onTouchMove={onTouchMove}
									onTouchEnd={onTouchEnd}
									style={{
										position: 'absolute',
										top: 0, left: 0, right: 0, bottom: 0,
										display: 'flex', alignItems: 'center', justifyContent: 'center',
										borderRadius: 12, boxShadow: '0 6px 18px rgba(0,0,0,0.08)', background: '#fff',
										overflow: 'hidden'
									}}>
									{/* current image */}
									<img
										src={TITULS[titulIndex].image}
										alt={TITULS[titulIndex].name}
										style={{
											maxWidth: '100%', maxHeight: '100%', objectFit: 'contain',
											transform: isAnimating && incomingDirection === 'next' ? 'translateX(-100%)' : isAnimating && incomingDirection === 'prev' ? 'translateX(100%)' : 'translateX(0)',
											transition: isAnimating ? 'transform 360ms cubic-bezier(.2,.8,.2,1)' : 'none',
											position: 'absolute'
										}}
									/>

									{/* incoming image */}
									{isAnimating && incomingIndex != null && (
										<img
											src={TITULS[incomingIndex].image}
											alt={TITULS[incomingIndex].name}
											onTransitionEnd={finishAnimation}
											style={{
												maxWidth: '100%', maxHeight: '100%', objectFit: 'contain',
												transform: incomingDirection === 'next' ? 'translateX(0)' : 'translateX(0)',
												transition: 'transform 360ms cubic-bezier(.2,.8,.2,1)',
												position: 'absolute',
												left: incomingDirection === 'next' ? '100%' : '-100%'
											}}
										/>
									)}
								</div>
							</div>

							{/* right preview */}
							<div style={{ width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: 0.9, cursor: 'pointer' }} onClick={() => setTitulIndex(nextTitulIndex)}>
								<img src={TITULS[nextTitulIndex].image} alt={TITULS[nextTitulIndex].name} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', borderRadius: 8, boxShadow: '0 4px 12px rgba(0,0,0,0.06)' }} />
							</div>
						</div>

						<div style={{ width: '100%', marginTop: 12, minHeight: 90, position: 'relative' }}>
							{/* current text */}
							<div style={{ position: 'absolute', top: 0, left: 0, right: 0, transition: 'transform 360ms cubic-bezier(.2,.8,.2,1), opacity 260ms', transform: isAnimating && incomingDirection === 'next' ? 'translateX(-20px)' : isAnimating && incomingDirection === 'prev' ? 'translateX(20px)' : 'translateX(0)', opacity: isAnimating ? 0 : 1 }}>
								<div style={{ fontWeight: 700, fontSize: 16 }}>{TITULS[titulIndex].name} {userPoints >= TITULS[titulIndex].points && <span style={{ color: '#34C38F', fontWeight: 600 }}>({t('ACHIEVED') || 'Achieved'})</span>}</div>
								<div style={{ color: '#666', fontSize: 13, marginBottom: 8 }}>{TITULS[titulIndex].points} {t('POINTS') || 'points'}</div>
								<ul>
									{TITULS[titulIndex].benefits.map((b, i) => <li key={i} style={{ fontSize: 13 }}>{b}</li>)}
								</ul>
							</div>

							{/* incoming text */}
							{isAnimating && incomingIndex != null && (
								<div style={{ position: 'absolute', top: 0, left: 0, right: 0, transition: 'transform 360ms cubic-bezier(.2,.8,.2,1), opacity 260ms', transform: incomingDirection === 'next' ? 'translateX(20px)' : 'translateX(-20px)', opacity: 1 }}>
									<div style={{ fontWeight: 700, fontSize: 16 }}>{TITULS[incomingIndex].name} {userPoints >= TITULS[incomingIndex].points && <span style={{ color: '#34C38F', fontWeight: 600 }}>({t('ACHIEVED') || 'Achieved'})</span>}</div>
									<div style={{ color: '#666', fontSize: 13, marginBottom: 8 }}>{TITULS[incomingIndex].points} {t('POINTS') || 'points'}</div>
									<ul>
										{TITULS[incomingIndex].benefits.map((b, i) => <li key={i} style={{ fontSize: 13 }}>{b}</li>)}
									</ul>
								</div>
							)}
						</div>

						<div style={{ display: 'flex', gap: 6, marginTop: 12 }}>
							{TITULS.map((_, i) => (
								<div key={i} onClick={() => setTitulIndex(i)} style={{ width: 10, height: 10, borderRadius: 999, background: i === titulIndex ? '#34C38F' : '#ddd', cursor: 'pointer' }} />
							))}
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button className="btn btn-outline-secondary" onClick={() => setShowTitulModal(false)}>{t('CLOSE') || 'Close'}</button>
				</Modal.Footer>
			</Modal>


			<Modal show={showPaymentModalClick} animation={false} centered dialogClassName="update-modal-width" backdrop="static" onHide={ClosePaymentModal}>
				<Modal.Header closeButton>
					<Modal.Title>
						{PAYMENT_METHODS[PaymentMethod].name}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form autoComplete="off">
						<div className="form-group">
							<label>{t('POS')}<span className="required-mark">*</span></label>
							<select value={selectedPosId || ""} onChange={handleSelectChangeClick}>
								<option value="" disabled>{t('CHOOSE_POS')}</option>
								{posDataAll.map((item) => (
									<option key={item.id} value={item.id}>
										{item.name}
									</option>
								))}
							</select>
						</div>
						<div className="form-group">
							<label>
								{t('AMOUNT')}<span className="required-mark">*</span>
							</label>

							<div className="d-flex align-items-stretch">
								<input
									type="text"
									value={amountIn}
									className="form-control"
									disabled
								/>

								<div className="d-flex flex-column ms-2">
									<button
										type="button"
										className="btn btn-outline-secondary py-0"
										onClick={() => handleIncrement(selectedPosId)}
										aria-label="Increase"
									>
										+
									</button>
									<button
										type="button"
										className="btn btn-outline-secondary py-0 mt-1"
										onClick={() => handleDecrement(selectedPosId)}
										aria-label="Decrease"
									>
										−
									</button>
								</div>
							</div>
						</div>

						<div className="alert alert-warning mt-2">
							{t('BILLING_NOTIFICATION')}
						</div>
						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100 me-2" onClick={ClosePaymentModal}>{t('CANCEL')}</button>
							<button
								type="button"
								className="btn btn-primary w-100"
								onClick={() => {
									const name = PAYMENT_METHODS[PaymentMethod]?.name;
									if (name === 'Click') return redirectToClick();
									if (name === 'Payme') return redirectToPayme();
									if (name === 'Multicard') return redirectToMulticard(); // uses proxy
								}}
							>
								{t('GO_TO_PAYMENT')}
							</button>

						</div>
					</form>
				</Modal.Body>
			</Modal>

			<Modal show={modalLogout} animation={false}
				centered dialogClassName="update-modal-width" backdrop="static" onHide={() => setModalLogout(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('LOGOUT')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{t('ARE_YOU_SURE_YOU_WANT_LOGOUT')}
				</Modal.Body>
				<Modal.Footer >
					<div className="d-flex w-100">
						<button className="btn btn-outline-danger w-100 me-2" onClick={() => setModalLogout(false)}>
							{t('CANCEL')}
						</button>
						<button className="btn btn-primary w-100" onClick={() => logout()}>{t('CONFIRM')}</button>
					</div>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default Header